/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportGoogleRowCreateDto
 */
export interface ImportGoogleRowCreateDto {
    /**
     * 
     * @type {string}
     * @memberof ImportGoogleRowCreateDto
     */
    invoiceNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ImportGoogleRowCreateDto
     */
    currency: ImportGoogleRowCreateDtoCurrencyEnum;
    /**
     * 
     * @type {Date}
     * @memberof ImportGoogleRowCreateDto
     */
    issueDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ImportGoogleRowCreateDto
     */
    sellDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ImportGoogleRowCreateDto
     */
    paymentDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ImportGoogleRowCreateDto
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof ImportGoogleRowCreateDto
     */
    exchangeRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportGoogleRowCreateDto
     */
    type: ImportGoogleRowCreateDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ImportGoogleRowCreateDto
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof ImportGoogleRowCreateDto
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof ImportGoogleRowCreateDto
     */
    projectNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportGoogleRowCreateDto
     */
    teamsNames?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportGoogleRowCreateDto
     */
    attachmentContent: string;
    /**
     * 
     * @type {string}
     * @memberof ImportGoogleRowCreateDto
     */
    attachmentName: string;
    /**
     * 
     * @type {string}
     * @memberof ImportGoogleRowCreateDto
     */
    comment?: string | null;
}


/**
 * @export
 */
export const ImportGoogleRowCreateDtoCurrencyEnum = {
    Pln: 'PLN',
    Usd: 'USD',
    Eur: 'EUR',
    Czk: 'CZK',
    Rub: 'RUB',
    Huf: 'HUF',
    Gbp: 'GBP',
    Bgn: 'BGN',
    Ron: 'RON',
    Hrk: 'HRK',
    Aud: 'AUD'
} as const;
export type ImportGoogleRowCreateDtoCurrencyEnum = typeof ImportGoogleRowCreateDtoCurrencyEnum[keyof typeof ImportGoogleRowCreateDtoCurrencyEnum];

/**
 * @export
 */
export const ImportGoogleRowCreateDtoTypeEnum = {
    Foreign: 'Foreign',
    Domestic: 'Domestic'
} as const;
export type ImportGoogleRowCreateDtoTypeEnum = typeof ImportGoogleRowCreateDtoTypeEnum[keyof typeof ImportGoogleRowCreateDtoTypeEnum];


/**
 * Check if a given object implements the ImportGoogleRowCreateDto interface.
 */
export function instanceOfImportGoogleRowCreateDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "invoiceNumber" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "issueDate" in value;
    isInstance = isInstance && "sellDate" in value;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "clientId" in value;
    isInstance = isInstance && "companyId" in value;
    isInstance = isInstance && "attachmentContent" in value;
    isInstance = isInstance && "attachmentName" in value;

    return isInstance;
}

export function ImportGoogleRowCreateDtoFromJSON(json: any): ImportGoogleRowCreateDto {
    return ImportGoogleRowCreateDtoFromJSONTyped(json, false);
}

export function ImportGoogleRowCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportGoogleRowCreateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'invoiceNumber': json['invoiceNumber'],
        'currency': json['currency'],
        'issueDate': (new Date(json['issueDate'])),
        'sellDate': (new Date(json['sellDate'])),
        'paymentDate': (new Date(json['paymentDate'])),
        'amount': json['amount'],
        'exchangeRate': !exists(json, 'exchangeRate') ? undefined : json['exchangeRate'],
        'type': json['type'],
        'clientId': json['clientId'],
        'companyId': json['companyId'],
        'projectNumber': !exists(json, 'projectNumber') ? undefined : json['projectNumber'],
        'teamsNames': !exists(json, 'teamsNames') ? undefined : json['teamsNames'],
        'attachmentContent': json['attachmentContent'],
        'attachmentName': json['attachmentName'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function ImportGoogleRowCreateDtoToJSON(value?: ImportGoogleRowCreateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'invoiceNumber': value.invoiceNumber,
        'currency': value.currency,
        'issueDate': (value.issueDate.toISOString()),
        'sellDate': (value.sellDate.toISOString()),
        'paymentDate': (value.paymentDate.toISOString()),
        'amount': value.amount,
        'exchangeRate': value.exchangeRate,
        'type': value.type,
        'clientId': value.clientId,
        'companyId': value.companyId,
        'projectNumber': value.projectNumber,
        'teamsNames': value.teamsNames,
        'attachmentContent': value.attachmentContent,
        'attachmentName': value.attachmentName,
        'comment': value.comment,
    };
}

